import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from '../../shared';
import { GenericDocContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class InternalSalesrMASupplierAccessService extends BaseApiTemplateService<GenericDocContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-sales-rma/login-entity-ep';
    this.httpClient = http;
  }

  public printJasperPdf(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string): Observable<Blob> {
    let params;
    if (customParam) {
      params = new HttpParams()
      .set('printServiceClassName', printServiceClassName)
      .set('printableFormatHdrGuid', printableFormatGuid)
      .set('customParam', customParam);
    } else {
      params = new HttpParams()
      .set('printServiceClassName', printServiceClassName)
      .set('printableFormatHdrGuid', printableFormatGuid);
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + '/print-jasper-pdf/' + guid,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }
}
